import styled, { css } from 'styled-components'
import colorsOptions from '../../fundamentals/colors-styles/constants'
import { checkboxStyleOptions } from './constants'
import {
  textStyleWeightOptions,
  textStyleWeightStyleOptions
} from '../../fundamentals/text-styles/constants'

const Container = styled.div`
  display: flex;
  justify-content: start;
`

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]}

  ${({ size = 'medium' }) => css`
    ${checkboxStyleOptions[size]?.container}
  `}

  ${({ isDimmed }) =>
    isDimmed &&
    css`
      opacity: 0.5;
    `}
`

const CheckboxRoot = styled.button`
  all: unset;
  box-sizing: border-box;
  background-color: ${colorsOptions.greys.white};
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ size = 'medium', value }) => css`
    border: ${value ? 'none' : `solid ${colorsOptions.greys['grey-90']}`};
    ${checkboxStyleOptions[size]?.root}
    &:focus {
      box-shadow:
        0 0 0 0.5px ${colorsOptions.greys.white},
        0 0 0 ${checkboxStyleOptions[size]?.borderWidth}
          ${colorsOptions.docuToolsOrange.orange};
    }
  `}

  &:focus {
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: '50%';
    border-color: ${colorsOptions.greys['grey-40']};
  }
`

const CheckboxIndicatorContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;

  & svg {
    stroke: ${colorsOptions.greys.white};
    color: ${colorsOptions.greys.white};

    & path {
      stroke: inherit;
    }
  }
`

const CheckboxStandard = styled(CheckboxRoot)`
  ${CheckboxIndicatorContainer} {
    background-color: ${colorsOptions.greys['grey-90']};
  }
  &:disabled {
    ${CheckboxIndicatorContainer} {
      background-color: ${colorsOptions.greys['grey-40']};
    }
  }
`

const CheckboxEmphasis = styled(CheckboxRoot)`
  border-color: ${colorsOptions.docuToolsOrange.orange};
  ${CheckboxIndicatorContainer} {
    background-color: ${colorsOptions.docuToolsOrange.orange};
  }
  &:disabled {
    ${CheckboxIndicatorContainer} {
      background-color: ${colorsOptions.greys['grey-40']};
    }
  }
`

const CheckboxError = styled(CheckboxRoot)`
  border-color: ${colorsOptions.semantics.danger.error};
  ${CheckboxIndicatorContainer} {
    background-color: ${colorsOptions.semantics.danger.error};
  }
  &:disabled {
    ${CheckboxIndicatorContainer} {
      background-color: ${colorsOptions.greys['grey-40']};
    }
  }
`

const StoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export {
  Container,
  CheckboxContainer,
  StoryContainer,
  CheckboxIndicatorContainer,
  CheckboxStandard,
  CheckboxEmphasis,
  CheckboxError
}
